import { Tooltip } from '@jisr-hr/ds-beta'
import { Button, Flex } from '@jisr-hr/ds'
import i18n from 'translations/i18n'
import {
  useAddReaction,
  useRemoveReaction,
  useUpdateReaction,
} from 'apis/OrgManagement/announcementSegrigation/useAnnouncementSeg'
import { handleReactionIcon } from 'containers/authorised/Announcement/utils'

const reactions = [
  { name: 'like', icon: 'thumbs-up' },
  { name: 'love', icon: 'heart' },
  { name: 'celebrate', icon: 'party-horn' },
  { name: 'funny', icon: 'face-smile' },
  { name: 'insightful', icon: 'lightbulb-04' },
]

interface AnnouncementWidgetProps {
  item: {
    id: number
    reaction?: {
      id: number
      reaction_type: string
    }
  }
  refetch: () => void
  width?: number
}

const ReactionsButton = ({ item, refetch, width }: AnnouncementWidgetProps) => {
  const { mutate: removeReaction } = useRemoveReaction()
  const { mutate: updateReaction } = useUpdateReaction()
  const { mutate: addReaction } = useAddReaction()
  const announcementReaction = item?.reaction
  const handleReaction = (
    oldReaction: { reaction_type: string; id: number } | undefined,
    selectedReaction: string,
  ) => {
    const reaction = {
      reactable_id: oldReaction ? oldReaction.id : item.id, // in Create Integer (ID of announcement or comment)
      reaction_type: selectedReaction,
      reactable_type: 'Announcement',
    }

    if (oldReaction) {
      if (oldReaction.reaction_type !== selectedReaction) {
        updateReaction({ reaction }, { onSuccess: () => refetch() })
      } else {
        removeReaction({ reaction }, { onSuccess: () => refetch() })
      }
    } else {
      addReaction({ reaction }, { onSuccess: () => refetch() })
    }
  }

  return (
    <>
      <Tooltip
        behavior="popover"
        minWidth="212px"
        placement="bottom"
        title={
          <Flex className="gap-2">
            {reactions.map((reaction, i) => {
              return (
                <Button
                  key={i}
                  leadingIcon={reaction.icon}
                  variant={
                    announcementReaction?.reaction_type === reaction.name ? 'tinted' : 'outlined'
                  }
                  color={
                    announcementReaction?.reaction_type === reaction.name ? 'primary' : 'neutral'
                  }
                  fullWidth
                  size="small"
                  onClick={() => {
                    handleReaction(announcementReaction, reaction.name)
                  }}
                />
              )
            })}
          </Flex>
        }
        triggerWidth={width ? `${width}px` : '100%'}
        trigger={
          <Button
            label={
              announcementReaction?.reaction_type
                ? i18n.t(`label.${announcementReaction?.reaction_type}`)
                : i18n.t(`label.like`)
            }
            leadingIcon={
              announcementReaction
                ? handleReactionIcon(announcementReaction.reaction_type)
                : 'thumbs-up'
            }
            variant="tinted"
            color={announcementReaction ? 'primary' : 'neutral'}
            fullWidth
            size="small"
          />
        }
      />
    </>
  )
}
export default ReactionsButton
